import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

export const fetchAttendance = createAsyncThunk(
  "attendance/fetchAttendance",
  async (params, thunkAPI) => {
    try {
      const state = thunkAPI.getState();
      const token = state.auth.token;
      if (!token) return;

      const user = state.auth.user;
      const isAgencyOrSupervisor = user?.is_agency || user?.is_supervisor || (!user?.is_supervisor && !user?.is_tl && !user?.is_tc && !user?.is_fa);
      const apiUrl = isAgencyOrSupervisor ? "auth/admin/telecaller-attendance/" : "auth/attendance/summary/";

      const response = await axios.get(apiUrl, {
        params: params,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      return response?.data?.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message ||
        error.message ||
        "Failed to fetch attendance data"
      );
    }
  }
);

export const updateBreak = createAsyncThunk(
  "attendance/updateBreak",
  async ({ action, break_type }, thunkAPI) => {
    try {
      const state = thunkAPI.getState();
      const token = state.auth.token;
      if (!token) return;

      const response = await axios.post(
        "auth/attendance/action/",
        { action, break_type },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response?.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message ||
        error.message ||
        "Failed to update break action"
      );
    }
  }
);


const attendanceSlice = createSlice({
  name: "attendance",
  initialState: {
    attendance_list: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAttendance.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAttendance.fulfilled, (state, action) => {
        state.loading = false;
        state.attendance_list = action.payload;
      })
      .addCase(fetchAttendance.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Something went wrong";
        state.attendance_list = [];
      });
  },
});

export default attendanceSlice.reducer;
